import { HelperService } from './../../../Services/helper.service';
import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FileName } from './../../../models/file-name';
import { AnalysisTypeDto } from '../../../models/dto/analysis-type.dto';


@Component({
  selector: 'app-patient-id-modal',
  templateUrl: './patient-id-modal.component.html',
  styleUrls: ['./patient-id-modal.component.css']
})
export class PatientIdModalComponent {
  @ViewChild('classic') public templateRef: TemplateRef<any>;

  @Output() patientId = new EventEmitter<FileName>();
  modalReference: NgbModalRef;
  form: UntypedFormGroup;
  fileExtension: string;
  fileName: string;
  analysisTypes: AnalysisTypeDto[];

  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
    size: 'md'
  };

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private helper: HelperService) {
    this.form = this.fb.group({
      id: ['', [Validators.required]],
      analysisType: ['', [Validators.required]]
    });
  }

  changesSubscribe() {
    this.idControl.valueChanges.subscribe(() => {
      this.idControl.patchValue(this.idControl.value ? this.idControl.value.split(' ').join('') : '', { emitEvent: false })
    });
  }

  get idControl() {
    return this.form.controls['id'];
  }

  get analysisTypeControl() {
    return this.form.controls['analysisType'];
  }

  open(displayName: string, analysisTypes: AnalysisTypeDto[], isFolder = false) {
    this.analysisTypes = analysisTypes;
    this.changesSubscribe();
    this.modalReference = this.modalService.open(this.templateRef, this.ngbModalOptions);
    if (isFolder) {
      // Folder name has no extension; use it verbatim as the suggested patient id.
      this.idControl.setValue(displayName);
      this.fileName = displayName;
      this.fileExtension = '';
    } else {
      const value = this.helper.patchFileName(displayName);
      this.idControl.setValue(value.name);
      this.fileName = value.name;
      this.fileExtension = value.extension;
    }
  }

  save() {
    this.form.markAllAsTouched();
    if (this.form.invalid) { return; }
    const fileName = new FileName();
    fileName.patientId = this.idControl.value;
    fileName.name = this.fileName;
    fileName.extension = this.fileExtension;
    fileName.analysisId = this.analysisTypeControl.value;
    this.patientId.emit(fileName);
    this.closeModal();
  }

  closeModal() {
    this.form.reset();
    this.modalReference.close();
  }
}
